<template>
    <div>
        <v-container class="mb-10">
            <v-form ref="form">
                <v-row>
                    <h2 class="pb-5 pl-7">{{ this.parentObject.pageTitle }} -<span class="page_title_value pl-2">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>
                <v-row>
                    <div class="pt-2 pl-7 pb-5">
                        <v-row>
                            <v-col>
                                <v-btn 
                                    color="warning" 
                                    style="width: 70px;"
                                    @click="backHandler" 
                                > 
                                    {{ $t('button.back') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-row>
                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5 ml-n1 mb-10">
                    <div>
                        <v-row>
                            <v-col cols="6" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.formcode')"
                                    ref="formcode"
                                    readonly
                                    :rules="[rules.required]"
                                    v-model="formData.formcode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.formname')"
                                    ref="formname"
                                    readonly
                                    :rules="[rules.required]"
                                    v-model="formData.formname"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.sectionname')"
                                    ref="sectname"
                                    readonly
                                    :rules="[rules.required]"
                                    v-model="formData.sectname"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('Setupformreviewsection.sectiontype')"
                                    ref="sectiontype"
                                    readonly
                                    :rules="[rules.required]"
                                    v-model="formData.secttype"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="mt-5 mb-10 px-5 ml-n1">
                        <v-row v-if="this.formData.secttype != 'Objective'">
                            <app-table
                            v-bind:parentObject="{
                                secttype: this.formData.secttype,
                                sectweightage: this.parentObject.data.sectweightage,
                                sectid : this.sectid,
                            }"
                            v-on:input="addItemHandler"
                        />
                        </v-row>
                        <v-row v-if="this.formData.secttype === 'Objective'">
                            <h2>{{ $t('pmformsetup.formdetailstatement')}} </h2>
                        </v-row>
                    </div>
                </v-container>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTableDetails.vue';

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },

            sectid : this.parentObject.sectid,
            formData: {
                formcode: this.parentObject.data.formcode,
                formname: this.parentObject.data.formname,
                sectname: this.parentObject.data.sectname,
                secttype: this.parentObject.data.secttype,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },

            errMsg: '',
            isErr: false,
        }
    },

    methods: {
        backHandler() {
            // this.$router.push({ name: "formsetupedit", params: { id: this.parentObject.formid } });
            this.$router.go(-1);
        },
    },

    mounted() {
    }
    
}
</script>